module.exports = __webpack_public_path__ + "img/rs_baby3.613ce2cc.jpg";